var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgToastErrorinline = function SvgToastErrorinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.2 16.152-8.127-14.68A2.34 2.34 0 0 0 11 .25a2.34 2.34 0 0 0-2.073 1.222L.8 16.152a2.35 2.35 0 0 0 .032 2.354 2.348 2.348 0 0 0 2.042 1.166h16.253a2.35 2.35 0 0 0 2.042-1.166c.43-.731.442-1.611.031-2.354Zm-10.987-9.34a.787.787 0 1 1 1.575 0v5.249a.787.787 0 1 1-1.575 0V6.81Zm.787 9.71a1.05 1.05 0 1 1 0-2.098 1.05 1.05 0 0 1 0 2.099Z",
    fill: "#fff"
  })));
};

export default SvgToastErrorinline;